import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 86.939 77.279',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      className="icon"
      d="M79.712,45.48l7.135-31.395A3.622,3.622,0,0,0,83.315,9.66H24.03L22.647,2.9A3.622,3.622,0,0,0,19.1,0H3.622A3.622,3.622,0,0,0,0,3.622V6.037A3.622,3.622,0,0,0,3.622,9.66H14.17L24.773,61.5a8.453,8.453,0,1,0,10.119,1.293H66.536a8.45,8.45,0,1,0,9.6-1.57l.833-3.664a3.622,3.622,0,0,0-3.532-4.425H32.922l-.988-4.83H76.18A3.622,3.622,0,0,0,79.712,45.48Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
